export interface FileMatch {
  field: ColumnKey | null;
  matched: boolean;
  matchedBy: string;
  columnIndex: number | null;
  columnHeader: string;
  required: boolean;
  recommended: boolean;
  values: string[];
  groupMatches?: FileMatches;
  errorType?: 'format' | 'duplicate';
  errorMsg?: string;
}

export type FileMatches = FileMatch[];

export interface NormalizeFile {
  filename?: string;
  headers: string[];
  rows: string[][] | null;
}

export interface ColumnMatchField {
  key: string;
  labels: string[];
  required: boolean;
  recommended: boolean;
  valueRegex?: RegExp[];
  allowedValues?: string[];
}

export enum ChipIconType {
  MATCHED = 'matched',
  SYSTEM_MATCHED = 'system_matched',
  UNMATCHED = 'unmatched',
  ERROR = 'error',
  ALL = 'all',
}

export enum ColumnMatchingStatus {
  MATCHED = 'matched',
  UNMATCHED = 'unmatched',
  ERROR = 'error',
  SYSTEM_MATCHED = 'system_matched',
  GROUP = 'group',
}

export enum ColumnKey {
  Unmatched = 'unmatched',
  AdminId = 'adminID',
  SubmissionDate = 'submissionDate',
  ClaimType = 'claimType',
  FirstName = 'firstName',
  LastName = 'lastName',
  Address = 'address',
  Address2 = 'address2',
  City = 'city',
  State = 'state',
  Country = 'country',
  Zip = 'zip',
  UnvalidatedEmail = 'unvalidatedEmail',
  ValidatedEmail = 'validatedEmail',
  PaymentEmail = 'paymentEmail',
  UnvalidatedPhone = 'unvalidatedPhone',
  ValidatedPhone = 'validatedPhone',
  PaymentPhone = 'paymentPhone',
  Units = 'units',
  IpAddress = 'ipAddress',
  Referrer = 'referrer',
  MailedIn = 'isMailedIn',
  ClassMemberId = 'classMemberID',
  AuthenticationPin = 'authenticationPin',
  ArtifactPaidAmount = 'artifactPaidAmount',
  UniquePayoutAmount = 'uniquePayoutAmount',
  PassesCaseSpecificValidation = 'passesCaseSpecificValidation',
  SubmitterType = 'submitterType',
}

export const REQUIRED_COLUMNS: ColumnKey[] = [
  ColumnKey.AdminId,
  ColumnKey.SubmissionDate,
  ColumnKey.ClaimType,
  ColumnKey.FirstName,
  ColumnKey.LastName,
  ColumnKey.Address,
  ColumnKey.City,
  ColumnKey.State,
  ColumnKey.Country,
  ColumnKey.Zip,
  ColumnKey.Units,
  ColumnKey.IpAddress,
];

export enum FileUploadView {
  UPLOAD = 'upload',
  MATCH_COLUMNS = 'match_columns',
  SUCCESS = 'success',
}

export type RecalculateResponse = {
  recalculated: boolean;
  error: string | null;
};
